import { RootState } from '@/store';
import { State } from './state';
import { ActionTree } from 'vuex';

import {
    FETCH_USER_PROFILES_FUNCTIONALITIES,
    CREATE_LOGGED_USER,
    SET_LOGGED_USER,
} from './types';

import { identityServerApi } from '@/api/identityserver.api';
import { MessageService } from '@/services/messageService';

export const actions: ActionTree<State, RootState> = {

    async [CREATE_LOGGED_USER]({ commit }, payload: State) {
        commit(SET_LOGGED_USER, payload);
    },
    async [FETCH_USER_PROFILES_FUNCTIONALITIES]({ commit }, payload: number) {
        return identityServerApi.getUserProfileFunctionality(payload).catch((error: any) => { MessageService.Error('Erro', error); });
    },
};
